import { sbEditable } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { renderRichtext } from '../../../lib/utils/renderRichtext'
import { GlossaryListItemBlok } from '../types'
import { Styled } from './GroupItem.styled'

export const GroupItem = ({ item }: { item: GlossaryListItemBlok }) => {
  return (
    <div key={item._uid} {...sbEditable(item)}>
      <Styled.ItemTitle>{item.headline}</Styled.ItemTitle>
      <Styled.ItemDescription className="prose">{renderRichtext(item.description)}</Styled.ItemDescription>
    </div>
  )
}
